import { RoutingHelpersService } from '@polaris-customerweb/sharedcomponents.shared';
import { once } from 'lodash-es';
import { Culture } from '../culture';

export const _getCultureCodeFromPath = (window: Window) => {
    const parse = window.location.pathname.match(
        RoutingHelpersService.culturePrefixRegex
    );
    if (parse?.length && parse.length > 0) {
        const cultureCode = parse[1].toLowerCase();
        if (Culture.isCultureCode(cultureCode)) {
            return cultureCode;
        }
    }

    return Culture.defaultCultureCode;
};

export const cultureCodeFactory = once((window: Window) =>
    _getCultureCodeFromPath(window)
);
